import isInternalRegex from "./Constants";
import * as buildEnvs from '../../../_envs.json';

const getDomainFromUrl = (url) =>
{
    try
    {
        const parsedUrl = new URL(url);
        return parsedUrl.hostname;
    }
    catch (e)
    {
        return null;
    }
}

const isInternalUrl = (url) =>
{
    const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'local';
    const urlDomain = getDomainFromUrl(url);
    const activeDomain = buildEnvs[activeEnv]?.GATSBY_DOMAIN || 'localhost';

    if (!urlDomain && !url?.includes(activeDomain))
    {
        return /^\/\w?/.test(url);
    }

    return isInternalRegex?.envs[activeEnv]?.test(url) || false;
}

export default isInternalUrl;